var localization = {
    searchfilter: 'Lo sentimos, no encontramos ningún resultado. Cambia tus opciones y trata otra vez.',
    insufficientdata: 'Lo sentimos, nuestros datos parecen estar incompletos o carecen de la información necesaria para mostrarte algo en este momento.',
    error: 'Algo saló mal! Encontramos un error y no podemos procesar tu solicitud en este momento.',
    takeaction: 'Este es un mensaje personalizado para decirte qué acción tomar.',
    noworkneeded: 'Excelente! Actualmente no tienes más elementos restantes que necesiten atención.',
    unauthorized: 'Lo sentimos, no tienes derechos de acceso a estos datos.',
};
export default localization;
